import { createContext } from "react";

export interface Media {
  cameraList: MediaDeviceInfo[] | undefined;
  changeCamera: (deviceId: string) => void;
  closeStream: () => void;
  hasCameraStarted: boolean;
  isCameraAllowed: boolean | undefined;
  isCameraBlocked: boolean;
  isCameraGranted: boolean;
  mediaStream: MediaStream | undefined;
  requestCameraAccess: () => Promise<boolean>;
  selectedCamera: string | undefined;
  setMediaStream: (tracks: MediaStream | undefined) => void;
  setSelectedCamera: (camera: string | undefined) => void;
  setVideo: (video: HTMLVideoElement | undefined) => void;
  retakePhoto: (setPhotoUriList: (photoUriList: string[]) => void) => void;
  startCamera: () => void;
  takePhoto: (setPhotoUriList: (photoUriList: string[]) => void) => void
  video: HTMLVideoElement | undefined;
}

export const MediaContext = createContext<Media>({
  cameraList: undefined,
  changeCamera: () => {},
  closeStream: () => {},
  hasCameraStarted: false,
  isCameraAllowed: undefined,
  isCameraBlocked: false,
  isCameraGranted: false,
  mediaStream: undefined,
  requestCameraAccess: async () => false,
  selectedCamera: undefined,
  setMediaStream: () => {},
  setSelectedCamera: () => {},
  setVideo: () => {},
  retakePhoto: () => {},
  startCamera: () => {},
  takePhoto: () => {},
  video: undefined,
});
